export default "__VITE_ASSET___RsfNgqn__"